import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface GoldButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  fullWidthMobile?: boolean;
}

/** CTA dorado con degradado, para el header y la sección de oferta. */
export function GoldButton({
  href,
  children,
  className = '',
  fullWidthMobile = true
}: GoldButtonProps) {
  return <a href={href} className={['group inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-center text-sm font-extrabold uppercase tracking-[0.04em] text-white sm:text-base', 'bg-[linear-gradient(135deg,#e0bf51_0%,#d4af37_45%,#b8922a_100%)]', 'shadow-[0_10px_26px_-10px_rgba(184,146,42,0.75)]', 'transition-[transform,box-shadow,filter] duration-200 ease-smooth', 'hover:-translate-y-0.5 hover:shadow-[0_16px_32px_-12px_rgba(184,146,42,0.85)] hover:brightness-[1.04]', 'active:translate-y-0', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-forest', fullWidthMobile ? 'w-full sm:w-auto' : '', className].join(' ')} data-id="element-437" data-mp="1aj8d8kqme7u6">
      <span data-id="element-438" data-mp="zzrgibxvmff4">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-439" data-mp="uyu4kh3gmhm2" />
    </a>;
}